module.exports = __webpack_public_path__ + "static/media/edit.28054b53.svg";